/*@ngInject*/
const FormRenderingUtil = function ($q, $rootScope, $window, $timeout, $compile, formViewerConstant,
                                    browserUtil, formComponentRenderingUtil) {

    let filterStrength = 2,
        frameTime = 0,
        lastLoop = getTime(),
        thisLoop;

    function getTime() {
        let perf = window.performance;

        if (browserUtil.isIE11() || browserUtil.isFirefox()) {
            return function () {
                return perf.now();
            };
        } else {
            return function () {
                return Date.now();
            };
        }
    }

    this.lastRenderSpeed = null;
    this.renderInterval = 1;
    this.renderChunkSize = 1;
    this.renderGroupSize = 1;

    this.viewportHeight = null;
    this.renderInternalId = null;

    this.optimizeFormWatchers = null;
    this.onInitialRenderingComplete = null;
    this.onFadeInRenderedSections = null;

    this.registerWatcherCallback = function (callback) {
        this.optimizeFormWatchers = callback;
    };

    this.registerInitialRenderingCompleteCallback = function (callback) {
        this.onInitialRenderingComplete = callback;
    };

    this.registerFadeInRenderedSectionsCallback = function (callback) {
        this.onFadeInRenderedSections = callback;
    };

    this.beginRendering = function (element, form) {
        this.defer = $q.defer();

        this.viewportHeight = element.height() || form.formHeight;

        form.renderedHeight = 0;
        form.initialRenderComplete = false;

        this.startLazyRendering.call(this, form, element);

        return this.defer.promise;
    };

    this.makeRenderPass = function (form, parentFormContainer, shouldRenderEntireForm) {
        let actionTaken = false;

        function makeSectionListPass(sectionList) {

            function isSupplementalPartiallyRendered(supplementalSectionList) {
                let result = false,
                    partiallyRenderedSupplementalRows;

                _.map(supplementalSectionList, function (supplementalSection) {
                    partiallyRenderedSupplementalRows = _.filter(supplementalSection.rowList, findPartiallyRenderedRows);

                    if (partiallyRenderedSupplementalRows.length) {
                        result = true;
                    }
                });

                return result;
            }

            function findPartiallyRenderedRows(row) {
                let result;

                if (row.sectionList) {
                    result = isSupplementalPartiallyRendered(row.sectionList);
                }
                else {
                    result = !row.fullyRendered;
                }
                return result;
            }

            _.map(sectionList, function (section) {
                let partiallyRenderedRows,
                    newSectionTpl;

                if ((!actionTaken || shouldRenderEntireForm) && !section.fullyRendered) {

                    if (!section.viewContainer) {

                        if (form.isConfigurableForm) {
                            formComponentRenderingUtil.createConfigurableSectionComponent(section, parentFormContainer, shouldRenderEntireForm);
                        }
                        else {
                            formComponentRenderingUtil.createSectionComponent(section, parentFormContainer, shouldRenderEntireForm);
                        }
                    }

                    if (!section.fullyRendered) {
                        makeRowListPass.call(this, section.rowList, section.viewContainer);
                        partiallyRenderedRows = _.filter(section.rowList, findPartiallyRenderedRows);
                        section.partiallyRendered = partiallyRenderedRows.length > 0;
                        section.fullyRendered = partiallyRenderedRows.length === 0;
                    }
                }
            }.bind(this));

        }

        function makeRowListPass(rowList, parentSectionContainer) {
            let renderChunkCount = 0;

            _.map(rowList, function (row) {

                if (!actionTaken || shouldRenderEntireForm) {

                    if (!row.fullyRendered) {

                        if (!row.addedToView) {

                            if (form.isConfigurableForm) {
                                formComponentRenderingUtil.createConfigurableRowComponent(row, parentSectionContainer);
                            }
                            else {
                                formComponentRenderingUtil.createRow(row, parentSectionContainer);
                            }

                            row.addedToView = true;

                            if (row.sectionList) {
                                form.renderedHeight += row.formHeight;
                            }
                            else if (row.rowList) {
                                form.renderedHeight += row.rowHeight;
                            }
                            else {
                                form.renderedHeight += row.rowHeight;
                            }
                        }

                        if (row.sectionList) {
                            row.fullyRendered = true;
                            actionTaken = true;
                            formComponentRenderingUtil.createSupplementalFormComponent(row, row.viewContainer);
                        }
                        else if (row.rowList) {
                            row.fullyRendered = true;
                            renderChunkCount += 1;

                            if (renderChunkCount >= this.renderChunkSize) {
                                actionTaken = true;
                            }

                            formComponentRenderingUtil.createRowRepeaterComponent(row, row.viewContainer, form.isConfigurableForm);
                        }
                        else {
                            _.map(row.fieldStructureList, function (fieldStructure) {
                                if ((!actionTaken && !fieldStructure.rendered) || shouldRenderEntireForm) {
                                    if (form.isConfigurableForm) {
                                        formComponentRenderingUtil.createConfigurableComponent(fieldStructure, row.viewContainer);
                                    }

                                    else {
                                        formComponentRenderingUtil.createComponentByType(fieldStructure, row.viewContainer);
                                    }

                                    fieldStructure.rendered = true;
                                    renderChunkCount += 1;

                                    if (renderChunkCount >= this.renderChunkSize) {
                                        actionTaken = true;
                                    }
                                }
                            }.bind(this));

                            row.fullyRendered = _.filter(row.fieldStructureList, {rendered: true}).length === row.fieldStructureList.length;
                        }
                    }
                }

            }.bind(this));
        }

        makeSectionListPass.call(this, form.sectionList);
    };

    this.startLazyRendering = function (form, parentFormViewerContainer) {
        let newFormTpl = formComponentRenderingUtil.createFormComponent(),
            render = function () {
                let sourceSections = form.sectionList,
                    sourceSectionsFullyRendered,
                    isRendering;

                this.makeRenderPass.call(this, form, newFormTpl);

                sourceSectionsFullyRendered = _.filter(sourceSections, function (section) {
                    return section.fullyRendered;
                });

                isRendering = sourceSectionsFullyRendered.length !== sourceSections.length;

                if ((form.renderedHeight > this.viewportHeight || !isRendering) && !form.initialRenderComplete) {
                    form.initialRenderComplete = true;
                    $rootScope.$broadcast(formViewerConstant.INITIAL_RENDERING_COMPLETE);

                    if (this.onInitialRenderingComplete) {
                        this.onInitialRenderingComplete();
                    }
                }

                if (form.initialRenderComplete && this.onFadeInRenderedSections) {
                    this.onFadeInRenderedSections();
                }

                if (!isRendering && !form.renderingComplete) {
                    form.renderingComplete = true;
                    this.defer.resolve();
                    $rootScope.$broadcast(formViewerConstant.event.FORM_LAZY_RENDERING_END);
                }
            }.bind(this),
            renderGroup = function () {
                if (!form.initialRenderComplete) {
                    this.renderInterval = 1;
                    this.renderChunkSize = 10;
                    this.renderGroupSize = 10;
                }
                else {
                    if (this.lastRenderSpeed < 5) {
                        this.renderInterval = 1;
                        this.renderChunkSize = 3;
                        this.renderGroupSize = 2;
                    }
                    else {
                        this.renderInterval = 1;
                        this.renderChunkSize = 5;
                        this.renderGroupSize = 2;
                    }
                }

                _.times(this.renderGroupSize, function () {
                    if (!form.initialRenderComplete && form.renderedHeight <= this.viewportHeight) {
                        render();
                    }
                    else if (form.initialRenderComplete) {
                        render();
                    }
                }.bind(this));

                if (this.optimizeFormWatchers) {
                    this.optimizeFormWatchers();
                }

                let thisFrameTime = (thisLoop = getTime()) - lastLoop;
                frameTime += (thisFrameTime - frameTime) / filterStrength;
                lastLoop = thisLoop;

                if (!form.renderingComplete) {
                    this.renderInternalId = $timeout(renderGroup, this.renderInterval);
                }
            }.bind(this);

        newFormTpl.insertAfter(parentFormViewerContainer.find('.formHeader'));
        this.renderInternalId = $timeout(renderGroup, this.renderInterval);
    };

    this.insertSupplemental = function (precedingRow, form) {
        let parentRowContainer = formComponentRenderingUtil.createRow(form, precedingRow, /*isAdvancedInsertion=*/true, /*insertAfter=*/true),
            formRowContainer = parentRowContainer.find('.formRowContainer');
        form.renderedHeight = 0;
        return formComponentRenderingUtil.createSupplementalFormComponent(form, formRowContainer);
    };

    this.renderSupplemental = function (parentFormContainer, form) {
        let newFormTpl = formComponentRenderingUtil.createFormComponent(),
            shouldRenderEntireForm = true;

        form.renderedHeight = 0;

        this.makeRenderPass.call(this, form, parentFormContainer, shouldRenderEntireForm);
        newFormTpl.insertAfter(parentFormContainer.find('.formHeader'));
        if (this.optimizeFormWatchers) {
            this.optimizeFormWatchers();
        }
    };

    this.insertNewRow = function (newRowConfig) {
        let isAdvancedInsertion = true;

        formComponentRenderingUtil.createConfigurableRowComponent(newRowConfig.row, newRowConfig.dropZoneRow, isAdvancedInsertion, newRowConfig.createAfterDropZone);

        $timeout(function () {
            formComponentRenderingUtil.createConfigurableComponent(newRowConfig.row.fieldStructureList[0], newRowConfig.row.viewContainer);
        }, 10);
    };

    this.insertNewComponent = function (newComponentConfig) {
        if (newComponentConfig.createAfterDropZone) {
            this.createConfigurableComponentAfter(newComponentConfig.fieldStructure, newComponentConfig.targetSibling, newComponentConfig.isRowRepeater);
        }
        else {
            this.createConfigurableComponentBefore(newComponentConfig.fieldStructure, newComponentConfig.targetSibling, newComponentConfig.isRowRepeater);
        }
    };

    this.insertNewSection = function (newSectionConfig) {
        if(newSectionConfig.createAfterDropZone) {
            formComponentRenderingUtil.createConfigurableSectionAfter(newSectionConfig.sectionStructure, newSectionConfig.dropZoneSection);
        }
        else {
            formComponentRenderingUtil.createConfigurableSectionBefore(newSectionConfig.sectionStructure, newSectionConfig.dropZoneSection);
        }
    };

    this.insertNewRowRepeater = function (newRowRepeaterConfig) {
        let rowStructure = newRowRepeaterConfig.rowStructure,
            dropZoneRow = newRowRepeaterConfig.dropZoneRow,
            advancedInsert = true,
            createAfterDropZone = newRowRepeaterConfig.createAfterDropZone;

        formComponentRenderingUtil.createConfigurableRowRepeaterComponent(rowStructure, dropZoneRow, advancedInsert, createAfterDropZone);
    };

    this.createConfigurableComponentBefore = function (fieldStructure, targetSibling, hideLabel) {
        return formComponentRenderingUtil.createConfigurableComponentBefore(fieldStructure, targetSibling, hideLabel);
    };

    this.createConfigurableComponentAfter = function (fieldStructure, targetSibling, hideLabel) {
        return formComponentRenderingUtil.createConfigurableComponentAfter(fieldStructure, targetSibling, hideLabel);
    };

    this.createConfigurableRowRepeaterComponent = function (rowStructure, parentSectionContainer, advancedInsertion, insertAfter) {
        formComponentRenderingUtil.createConfigurableRowComponent(rowStructure, parentSectionContainer, advancedInsertion, insertAfter);

        $timeout(function () {
            formComponentRenderingUtil.createRowRepeaterComponent(rowStructure, rowStructure.viewContainer, true);
        }, 10);
    };

    this.createConfigurableRowRepeaterComponentBefore = function (rowStructure, parentSectionContainer) {
        let advancedInsertion = true,
            insertAfter = false;

        this.createConfigurableRowRepeaterComponent(rowStructure, parentSectionContainer, advancedInsertion, insertAfter);
    };

    this.createConfigurableRowRepeaterComponentAfter = function (rowStructure, parentSectionContainer) {
        let advancedInsertion = true,
            insertAfter = true;

        this.createConfigurableRowRepeaterComponent(rowStructure, parentSectionContainer, advancedInsertion, insertAfter);
    };

    this.createConfigurableComponent = function (fieldStructure, parentRowContainer) {
        return formComponentRenderingUtil.createConfigurableComponent(fieldStructure, parentRowContainer);
    };
};

angular.module('umFormViewer').service('formRenderingUtil', FormRenderingUtil);
